<script>
    import { menuVisible } from '../../stores'

    let visible;

    menuVisible.subscribe(value => {
        visible = value;
    })

    const handleClick = () => {
        menuVisible.update(value => !value)
    };
</script>

<buton class="menu-icon {visible ? 'menu-visible' : ''}" on:click={handleClick}>
    <div class="bars">
        <div class="bar1"></div>
        <div class="bar2"></div>
        <div class="bar3"></div>
    </div>
</buton>